import { render, staticRenderFns } from "./shipment-list.vue?vue&type=template&id=3a10da02&scoped=true"
import script from "./shipment-list.vue?vue&type=script&lang=js"
export * from "./shipment-list.vue?vue&type=script&lang=js"
import style0 from "./shipment-list.vue?vue&type=style&index=0&id=3a10da02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a10da02",
  null
  
)

export default component.exports